import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';
import { FormItem, Select } from 'formik-antd';
import { getIn } from 'formik';

import { getUrlFromEvent, simpleFilterOptions } from 'utils/form';

import { SingleFileUpload } from 'components/form/upload';
import { DB_PREFIX_QUALIFICATIONS as DB_PREFIX } from './constants';

import StagePropTypes from './prop-types';

const getFile = (path, values) => {
  if (!values[path]) return null;
  if (!values[path].fileURL) return null;
  return values[path].fileURL;
};

const QualificationInput = ({
  label,
  name,
  levels,
  values,
  setFieldValue,
  isSubmitting,
  uploadTo,
  errors,
}) => {
  const prefix = `${DB_PREFIX}.${name}`;
  const errorLevel = getIn(errors, `${prefix}.level`);
  const errorFileURL = getIn(errors, `${prefix}.fileURL`);
  const field = values[DB_PREFIX][name] || {};

  const file = getFile(name, values[DB_PREFIX])
    ? {
        name: `${prefix}.fileURL`,
        url: getFile(name, values[DB_PREFIX]),
      }
    : undefined;

  return (
    <>
      <h3>{label}</h3>

      <FormItem name={`${prefix}.level`}>
        {errorLevel != null ? (
          <Alert
            message={errorLevel}
            type="error"
            showIcon
            style={{ marginBottom: 'var(--margin-01)' }}
          />
        ) : null}

        <Select
          name={`${DB_PREFIX}.${name}.level`}
          placeholder={`Please select the level for ${label}`}
          showSearch
          filterOption={simpleFilterOptions}
          allowClear
        >
          {levels.map((value, i) => (
            <Select.Option key={`${value}-${i}`} value={value}>
              {value}
            </Select.Option>
          ))}
        </Select>
      </FormItem>

      {field.level != null ? (
        <FormItem
          name={`${prefix}.fileURL`}
          style={{ marginTop: 'var(--margin-02)' }}
        >
          {errorFileURL != null ? (
            <Alert
              message={errorFileURL}
              type="error"
              showIcon
              style={{ marginBottom: 'var(--margin-01)' }}
            />
          ) : null}
          <SingleFileUpload
            className="ant-upload ant-upload-drag"
            title={label}
            subTitle="Click in this area to upload"
            file={file}
            uploadTo={uploadTo}
            multiple={false}
            showUploadList
            disabled={file != null || isSubmitting}
            onClear={() => {
              setFieldValue(`${prefix}.fileURL`, null);
            }}
            onChange={(e) => {
              setFieldValue(`${prefix}.fileURL`, getUrlFromEvent(e));
            }}
          />
        </FormItem>
      ) : null}
    </>
  );
};

QualificationInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  levels: PropTypes.arrayOf(PropTypes.string).isRequired,
  values: StagePropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  uploadTo: PropTypes.string.isRequired,
  errors: PropTypes.shape({}).isRequired,
};

export default QualificationInput;
